import { PartnerSlug } from "types/general";
import { colors } from "utils/theme";

export const PARTNERS = [
  "all",
  PartnerSlug.msufcu,
  PartnerSlug.csc,
  PartnerSlug.cusg,
  PartnerSlug["national-debt-relief"],
  "none",
];

export const COLORS = {
  all: colors.azure,
  [PartnerSlug.msufcu]: "#004F38",
  [PartnerSlug.csc]: "#44A324",
  [PartnerSlug.cusg]: "#004d98",
  [PartnerSlug["national-debt-relief"]]: "#A1001D",
  none: colors.heliotrope,
};

export const DEFAULT_PARTNERS = new Set(PARTNERS.slice(0, 3));
